var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,4v16h6.3c-0.5-0.9-0.7-1.9-0.7-3c0-3.5,2.9-6.4,6.4-6.4c0.7,0,1.4,0.1,2,0.3L19,4H5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,4v16h6.3c-0.5-0.9-0.7-1.9-0.7-3s0.3-2.1,0.7-3H11v-2h2c1.1-0.9,2.5-1.4,4-1.4c0.7,0,1.4,0.1,2,0.3L19,4H5z  M9,18H7v-2h2V18z M9,14H7v-2h2V14z M17,10H7V6h10V10z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    className: "st1",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    className: "st1",
    width: 10,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    className: "st1",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,14h0.3c0.4-0.8,1-1.5,1.7-2h-2V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.3,20H5V4h14l0,6.9c0.7,0.2,1.4,0.6,2,1.1V4c0-1.1-0.9-2-2-2H5C3.9,2,3,2.9,3,4v16c0,1.1,0.9,2,2,2h8 C12.3,21.5,11.7,20.8,11.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,13.5c-1-1-2.2-1.5-3.5-1.5c-1.4,0-2.6,0.5-3.5,1.5c-1,1-1.5,2.2-1.5,3.5s0.5,2.6,1.5,3.5 c1,1,2.2,1.5,3.5,1.5c1.4,0,2.6-0.5,3.5-1.5c1-1,1.5-2.2,1.5-3.5S21.5,14.4,20.5,13.5z M18.7,19.4l-2.2-2.2V14h1v2.8l1.9,1.9 L18.7,19.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCalculator);
export default __webpack_public_path__ + "static/media/bx-calculator.3498c50b0fd3237ed7afc22e3b47729d.svg";
export { ForwardRef as ReactComponent };